import { INumber } from '../../../model';
import { ITableColumnMultiHeader } from '../model';

export function getCollapseIndexStep<T>(
  currentColumnIndex: number,
  colSpan: number,
  rows?: ReadonlyArray<ITableColumnMultiHeader<T>>
) {
  let startIndex = 0;
  const stepRows = rows?.slice(0, currentColumnIndex) || [];
  if (stepRows.length === 1) {
    return [startIndex + 1, colSpan];
  }
  if (stepRows.length > 1) {
    stepRows.forEach((item, index) => {
      if (index + 1 >= currentColumnIndex) {
        return;
      }
      startIndex += Number(item.colSpan || 0);
    });
    return [startIndex + 1, startIndex + colSpan];
  }
  return [];
}

export const isMultiHeaderCollapse = (
  collapseIndex: INumber<ReadonlyArray<number>>,
  index: number
) => {
  const item = collapseIndex[index] || [];
  return !!item.length;
};

/**
 * @description 判断当前列是否在需要折叠的范围内
 * @param collapseIndex { 1: [0, 3], 2: [4, 10] }
 * @param index 5
 *
 * @example collapseIndex : index => true
 */
export const isColumnCollapse = (
  collapseIndex: INumber<ReadonlyArray<number>>,
  index: number
) => {
  let collapsed = false;
  let collapsedIndex = -1;
  let scopeIndex: ReadonlyArray<number> = [];

  // eslint-disable-next-line
  for (const i in collapseIndex) {
    const item = collapseIndex[i];
    if (item.length) {
      if (index >= item[0] && index <= item[1]) {
        collapsed = true;
        scopeIndex = item;
        collapsedIndex = Number(i);
        break;
      }
    }
  }
  return {
    collapsed,
    collapsedIndex,
    scopeIndex,
  };
};
